import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Grid, Box, Typography, Button } from '@material-ui/core';
import LinkIcon from '@material-ui/icons/Link';

import { ArrowDb, updateArrow } from '../redux/arrowDbSlice';
import useOneArrowDb from '../hooks/useOneArrowDb';

import BookTreeForLink from './BookTreeForLink';
import Arrow from './Arrow';

const LabelTypography = styled(Typography)`
  color: #9e9e9e;
`
const LargeLinkIcon = styled(LinkIcon)`
  font-size: 40px;
`
const BookTreeBox = styled(Box)`
  height: 60vh;
  margin-bottom: 8px;
  border: solid 1px black;
  overflow: auto;
`

type AddArrowLinkDialogProps = {
  open: boolean;
  id?: string;
  onClose: () => void;
}
const AddArrowLinkDialog: React.FC<AddArrowLinkDialogProps> = ({open, id, onClose}) => {
  const dispatch = useDispatch();
  const [checked, setChecked] = useState<string[]>([]);
  const [arrow, setArrow] = useState<ArrowDb>();
  const arrowValue = useOneArrowDb(id);

  useEffect(() => {
    setArrow(arrowValue);

    if (arrowValue) {
      let linkedIds: string[] = [];
      arrowValue.links?.map((link) => linkedIds.push(link));
      setChecked(linkedIds);
    }
  }, [arrowValue])

  const saveArrowLink = () => {
    if (id) dispatch(updateArrow({ id: id, links: checked }));
    onClose();
  }

  if (!id || !arrow) return <></>;
  return (
    <Dialog open={open} onClose={onClose} maxWidth='lg' fullWidth>
      <DialogTitle>この矢印から他のシートへのリンクを設定します</DialogTitle>
      <DialogContent>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={3}>
            <Arrow id={id} data={{ ...arrow, links: checked }} sibLength={1} linkPreview={true} />
          </Grid>
          <Grid item xs={1}><LargeLinkIcon /></Grid>
          <Grid item xs={8}>
            <LabelTypography variant="caption">チェックしたシートまでリンクを張る</LabelTypography>
            <BookTreeBox>
              <BookTreeForLink checked={checked} setChecked={setChecked} />
            </BookTreeBox>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant='text' color='primary' onClick={onClose}>
          キャンセル
        </Button>
        <Button variant='text' color='primary' onClick={saveArrowLink}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddArrowLinkDialog;
